import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import _Button from "../../../components/generic/_Button";
const ModalConfirm2FA = (props) => {
  /* eslint-disable no-unused-vars */
  const {
    title = "",
    description = "",
    visible,
    onClose,
    onAction,
    isLoading,
    data = null,
  } = props;

  const _onAction = () => {
    if (onAction) onAction();

    onClose();
  };
  return (
    <Modal show={visible} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <div className="text-xl font-semibold text-gray-600">{title}</div>
      </Modal.Header>
      <Modal.Body>
        <div className="text-md font-semibold text-gray-600">{description}</div>
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cancelar"
          style="none"
          onClick={onClose}
          loading={isLoading}
          disabled={isLoading}
        />

        <_Button
          title="Guardar"
          onClick={_onAction}
          style="primary"
          loading={isLoading}
          disabled={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
};

ModalConfirm2FA.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  isLoading: PropTypes.bool,
  data: PropTypes.object,
};

export default ModalConfirm2FA;
